<template>
  <div class="mortgage-rate-calculator">
    <MortgageCalculator :disclaimer="disclaimer"></MortgageCalculator>
  </div>
</template>

<script>
import MortgageCalculator from "./components/mortgageRateCalculator.vue";

export default {
  components: {
    MortgageCalculator
  },
  data() {
    return {
      disclaimer: this.disclaimerText
    }
  },
  mounted() {
      // this is an old comment - need to check for data here so we can remove the timeout
  },
  methods: {
  },
  props: {
    disclaimerText: String
  }
};
</script>
